import GroupAddIcon from "@mui/icons-material/GroupAdd";
import "./CoapplicantDetails.css";
import { useState, useEffect } from "react";
import Sidebar from "../../../Sidebar/Sidebar";
import axios from "axios";
import "react-toastify/dist/ReactToastify.css";
import { useLocation } from "react-router-dom";
import { url } from "../../../App";
import Cookies from "js-cookie";
import { AiOutlineEye } from "react-icons/ai";
import CoapplicantModal from "./CoapplicantModal";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const ViewCoApplicantDetails = () => {
  const token = Cookies.get("Token");
  const email = Cookies.get("Email");
  const [open, setOpen] = useState(false);
  const [isOpen, setIsOpen] = useState(true);
  const openView = (val) => setIsOpen(val);
  const [coapplicantData, setcoapplicantData] = useState([]);
  const [modalData, setModalData] = useState(null);
  const [photoUrl, setPhotoUrl] = useState("");
  const [finalDocName, setfinalDocName] = useState("");
  const [finalDocType, setfinalDocType] = useState("");
  const [borrowerSelfie, setBorrowerSelfie] = useState({
    doc: "",
    type: "",
  });
  const [coapplicantBorrowerUniqueNo, setCoapplicantBorrowerUniqueNo] = useState("");
  const [coapplicantLoanId, setCoapplicantLoanId] = useState("");
  const [coapplicantName, setCoapplicantName] = useState("");
  const [coapplicantDob, setCoapplicantDob] = useState("");
  const [coapplicantGender, setCoapplicantGender] = useState("");
  const [coapplicantPhoneNumber, setCoapplicantPhoneNumber] = useState("");
  const [coapplicantEmail, setCoapplicantEmail] = useState("");
  const [coapplicantMaritalStatus, setCoapplicantMaritalStatus] = useState("");
  const [coapplicantEducationalQualification, setCoapplicantEducationalQualification] = useState("");
  const [coapplicantRelationship, setCoapplicantRelationship] = useState("");
  const [coapplicantFatherName, setCoapplicantFatherName] = useState("");
  const [coapplicantProfession, setCoapplicantProfession] = useState("");
  const [coapplicant_compute_income, setcoapplicant_compute_income] = useState(false);
  const [coapplicant_category, setcoapplicant_category] = useState("");
  const [coapplicant_mothertongue, setcoapplicant_mothertongue] = useState("");
  const [coapplicant_religion, setcoapplicant_religion] = useState("");
  const [coapplicant_dateofmarriage, setcoapplicant_dateofmarriage] = useState("");
  const [coapplicant_familystructure, setcoapplicant_familystructure] = useState("");
  const [coapplicant_panno, setcoapplicant_panno] = useState("");
  const [coapplicant_aadharno, setcoapplicant_aadharno] = useState("");
  const [coapplicant_voterno, setcoapplicant_voterno] = useState("");
  const [openModal, setopenModal] = useState(false);
  const [addressPresent, setAddressPresent] = useState(false);
  const [primaryPresent, setPrimaryPresent] = useState(false);
  const [surrogatePresent, setSurrogatePresent] = useState(false);
  const [obligationPresent, setObligationPresent] = useState(false);
  const [surrogateType, setsurrogateType] = useState("");

  const [isEditableMobile, setIsEditableMobile] = useState(false);
  const [isEditableEmail, setIsEditableEmail] = useState(false);
  const [editedMobile, setEditedMobile] = useState(coapplicantPhoneNumber);
  const [editedEmail, setEditedEmail] = useState(coapplicantEmail);
  const [showFieldset, setShowFieldset] = useState(false);
  const [showFieldset2, setShowFieldset2] = useState(false);
  const [file, setFile] = useState(null);
  const [saveBtnDisabled, setSaveBtnDisabled] = useState(true);
  const [saveBtnDisabled2, setSaveBtnDisabled2] = useState(true);
  const [editBtnDisabled, setEditBtnDisabled] = useState(true);
  const [editBtnDisabled2, setEditBtnDisabled2] = useState(true);
  const [borrowerOtp, setBorrowerOtp] = useState("");
  const [editPermission, setEditPermission] = useState(false);
  const [formattedDob, setFormattedDob] = useState(null);
  const [formattedDom, setFormattedDom] = useState(null);

  const EMAIL = Cookies.get('Email');
  const TOKEN = Cookies.get('Token');

  //eslint-disable-next-line
  const EMAIL_REGEX = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

  const { state } = useLocation();
  // console.log(state)

  const openModalDetails = (val) => {
    setModalData(val);
    setopenModal(true);
  };

  const closeModalDetails = () => {
    setopenModal(false);
  };

  useEffect(() => {
    axios.post(url + "/user/getsingle", {
      token: token,
      email: email,
      useremail: email
    }).then((res) => {
      if (email === "rupesh.bishnoi@credin.in") {
        setEditPermission(true);
      } else {
        console.log(res?.data[0]);
        if (res.data[0]?.permission?.updateCoapplicantDetails === true) {
          setEditPermission(true);
        }
      }
    })

    axios
      .post(url + "/coapplicant/getsingle", {
        token: token,
        email: email,
        coapplicant_id: state.coapplicant_id,
      })
      .then((res) => {
        // console.log(res);
        // console.log(res.data[0]?.coapplicant_residence_type);
        setPhotoUrl(res.data[0]?.coapplicant_selfphoto);
        setfinalDocName(res.data[0]?.coapplicant_selfphoto?.doc_name);
        setfinalDocType(res.data[0]?.coapplicant_selfphoto?.doc_type);
        setCoapplicantBorrowerUniqueNo(res.data[0]?.coapplicant_borrower_uniqueno);
        setCoapplicantLoanId(res.data[0]?.coapplicant_loan_id);
        setCoapplicantName(res.data[0]?.coapplicant_name);
        setCoapplicantDob(res.data[0]?.coapplicant_dob);
        setCoapplicantGender(res.data[0]?.coapplicant_gender);
        setCoapplicantPhoneNumber(res.data[0]?.coapplicant_mobile);
        setCoapplicantEmail(res.data[0]?.coapplicant_email);
        setCoapplicantMaritalStatus(res.data[0]?.coapplicant_marital_status);
        setCoapplicantEducationalQualification(res.data[0]?.coapplicant_education);
        setCoapplicantRelationship(res.data[0]?.coapplicant_relationship);
        setCoapplicantFatherName(res.data[0]?.coapplicant_fathername);
        setCoapplicantProfession(res.data[0]?.coapplicant_profession_type);
        setcoapplicant_compute_income(JSON.stringify(res.data[0]?.coapplicant_compute_income));
        setcoapplicant_category(res.data[0]?.coapplicant_category);
        setcoapplicant_mothertongue(res.data[0]?.coapplicant_mother_tongue);
        setcoapplicant_religion(res.data[0]?.coapplicant_religion);
        setcoapplicant_familystructure(res.data[0]?.coapplicant_family_structure);
        setcoapplicant_dateofmarriage(res.data[0]?.coapplicant_date_of_marriage);
        setcoapplicant_panno(res.data[0]?.coapplicant_panno);
        setcoapplicant_aadharno(res.data[0]?.coapplicant_aadharno);
        setcoapplicant_voterno(res.data[0]?.coapplicant_voterno);
        setEditedMobile(res.data[0]?.coapplicant_mobile);
        setEditedEmail(res.data[0]?.coapplicant_email);
        const arrayofCoapplicant = [];
        //address
        arrayofCoapplicant.push(
          
          {
            label: "Residence Type",
            Value: res.data[0]?.coapplicant_residence_type,
            section: "Co-applicant Details",
          },
          {
            label: "Address",
            Value: res.data[0]?.coapplicant_residence_address,
            section: "Co-applicant Details",
          },
          {
            label: "PIN Code",
            Value: res.data[0]?.coapplicant_pincode,
            section: "Co-applicant Details",
          },
          {
            label: "State",
            Value: res.data[0]?.coapplicant_state,
            section: "Co-applicant Details",
          },
          {
            label: "City",
            Value: res.data[0]?.coapplicant_city,
            section: "Co-applicant Details",
          },
          {
            label: "Sub District",
            Value: res.data[0]?.coapplicant_subDistrict,
            section: "Co-applicant Details",
          },
          {
            label: "Locality/Village",
            Value: res.data[0]?.coapplicant_locality,
            section: "Co-applicant Details",
          }
        );

        //obligations
        arrayofCoapplicant.push(
          {
            label: "Number of Active Loans",
            Value: res.data[0]?.coapplicant_number_of_active_loans,
            section: "Obligations",
          },
          {
            label: "Total Monthly Active EMI Amount",
            Value: res.data[0]?.coapplicant_total_monthly_active_emi_amount,
            section: "Obligations",
          }
        );

        //surrogate
        if (res.data[0]?.coapplicant_surrogate_business_details !== undefined) {
          for (let data of res.data[0].coapplicant_surrogate_business_details) {
            setsurrogateType(data.professionType);
            if (data.professionType === "SELF-EMPLOYED") {
              arrayofCoapplicant.push(
                {
                  label: "Business Type",
                  Value: data.typeOfBusiness,
                  section: "Surrogate",
                },
                {
                  label: "Business Name",
                  Value: data.businessName,
                  section: "Surrogate",
                },
                {
                  label: "Mantri Name",
                  Value: data.mantriName,
                  section: "Surrogate",
                },
                {
                  label: "Mantri Number",
                  Value: data.mantriNumber,
                  section: "Surrogate",
                },
                {
                  label: "Business Income(Monthly)",
                  Value: data.businessIncome,
                  section: "Surrogate",
                },
                {
                  label: "Business Vintage (Months)",
                  Value: data.businessVintage,
                  section: "Surrogate",
                },
                {
                  label: "Income Mode",
                  Value: data.businessIncomeMode,
                  section: "Surrogate",
                },
                {
                  label: "Address",
                  Value: data.businessAddress,
                  section: "Surrogate",
                },
                {
                  label: "Pin Code",
                  Value: data.businessPinCode,
                  section: "Surrogate",
                },
                {
                  label: "State Name",
                  Value: data.businessState,
                  section: "Surrogate",
                },
                {
                  label: "City Name",
                  Value: data.businessCity,
                  section: "Surrogate",
                },
                {
                  label: "Sub District",
                  Value: data.businessSubDist,
                  section: "Surrogate",
                },
                {
                  label: "Locality/Village",
                  Value: data.businessLocality,
                  section: "Surrogate",
                },
                {
                  label: "Landmark",
                  Value: data.businessLandmark,
                  section: "Surrogate",
                }
              );
            } else {
              arrayofCoapplicant.push(
                {
                  label: "Nature of Business",
                  Value: data.natureOfBusiness,
                  section: "Surrogate",
                },
                {
                  label: "Designation Name",
                  Value: data.designationName,
                  section: "Surrogate",
                },
                {
                  label: "Duration with Current Employer (In Months)",
                  Value: data.durationWithCurrentEmployer,
                  section: "Surrogate",
                },
                {
                  label: "Salary Mode",
                  Value: data.salaryMode,
                  section: "Surrogate",
                },
                {
                  label: "Current Salary Income(Monthly)",
                  Value: data.currentSalary,
                  section: "Surrogate",
                },
                {
                  label: "Previous Salary",
                  Value: data.prevSalary,
                  section: "Surrogate",
                },
                {
                  label: "Job Vintage (Months)",
                  Value: data.jobVintage,
                  section: "Surrogate",
                },
                {
                  label: "Office Number",
                  Value: data.officeNumber,
                  section: "Surrogate",
                },
                {
                  label: "Office HR Number",
                  Value: data.officeHrNumber,
                  section: "Surrogate",
                },
                {
                  label: "Company Address",
                  Value: data.companyAddress,
                  section: "Surrogate",
                },
                {
                  label: "Pin Code",
                  Value: data.companyPinCode,
                  section: "Surrogate",
                },
                {
                  label: "State Name",
                  Value: data.companyState,
                  section: "Surrogate",
                },
                {
                  label: "City Name",
                  Value: data.companyCity,
                  section: "Surrogate",
                },
                {
                  label: "Sub District",
                  Value: data.companySubDist,
                  section: "Surrogate",
                },
                {
                  label: "Locality/Village",
                  Value: data.companyLocality,
                  section: "Surrogate",
                },
                {
                  label: "Landmark",
                  Value: data.companyLandmark,
                  section: "Surrogate",
                }
              );
            }
          }
        }
        
        //Primary
        if (res.data[0]?.coapplicant_primary_business_details !== undefined) {
          if (res.data[0]?.coapplicant_profession_type === "SALARIED") {
            arrayofCoapplicant.push(
              {
                label: "Nature of Business",
                Value:
                  res.data[0].coapplicant_primary_business_details?.NatureOfBusiness,
                section: "Primary Business Details",
              },
              {
                label: "Company Type",
                Value:
                  res.data[0].coapplicant_primary_business_details?.CompanyType,
                section: "Primary Business Details",
              },
              {
                label: "Designation Name",
                Value:
                  res.data[0].coapplicant_primary_business_details?.DesignationName,
                section: "Primary Business Details",
              },
              {
                label: "Duration with Current Employer (In Months)",
                Value:
                  res.data[0].coapplicant_primary_business_details?.DurationWithCurrentEmployer,
                section: "Primary Business Details",
              },
              {
                label: "Salary Mode",
                Value:
                  res.data[0].coapplicant_primary_business_details?.SalaryMode,
                section: "Primary Business Details",
              },
              {
                label: "Current Salary Income(Monthly)",
                Value:
                  res.data[0].coapplicant_primary_business_details?.CurrentSalaryIncome,
                section: "Primary Business Details",
              },
              {
                label: "Previous Salary",
                Value:
                  res.data[0].coapplicant_primary_business_details?.PreviousSalary,
                section: "Primary Business Details",
              },
              {
                label: "Job Vintage (Months)",
                Value:
                  res.data[0].coapplicant_primary_business_details?.JobVintage,
                section: "Primary Business Details",
              },
              {
                label: "Office Number",
                Value:
                  res.data[0].coapplicant_primary_business_details?.OfficeNumber,
                section: "Primary Business Details",
              },
              {
                label: "Office HR Number",
                Value:
                  res.data[0].coapplicant_primary_business_details?.OfficeHrNumber,
                section: "Primary Business Details",
              },
              {
                label: "Department",
                Value:
                  res.data[0].coapplicant_primary_business_details?.Department,
                section: "Primary Business Details",
              },
              {
                label: "Employee Code",
                Value:
                  res.data[0].coapplicant_primary_business_details?.EmployeeCode,
                section: "Primary Business Details",
              },
              {
                label: "Date of Joining",
                Value:
                  res.data[0].coapplicant_primary_business_details?.DateOfJoining,
                section: "Primary Business Details",
              },
              {
                label: "Company Address",
                Value:
                  res.data[0].coapplicant_primary_business_details?.CompanyAddress,
                section: "Primary Business Details",
              },
              {
                label: "Company PIN Code",
                Value:
                  res.data[0].coapplicant_primary_business_details?.CompanyPinCode,
                section: "Primary Business Details",
              },
              {
                label: "Company State",
                Value:
                  res.data[0].coapplicant_primary_business_details?.CompanyState,
                section: "Primary Business Details",
              },
              {
                label: "Company City",
                Value:
                  res.data[0].coapplicant_primary_business_details?.CompanyCity,
                section: "Primary Business Details",
              },
              {
                label: "Company Sub District",
                Value:
                  res.data[0].coapplicant_primary_business_details?.CompanySubDistrict,
                section: "Primary Business Details",
              },
              {
                label: "Company Locality/Village",
                Value:
                  res.data[0].coapplicant_primary_business_details?.CompanyLocality,
                section: "Primary Business Details",
              },
              {
                label: "Company Landmark",
                Value:
                  res.data[0].coapplicant_primary_business_details?.CompanyLandmark,
                section: "Primary Business Details",
              },
              {
                label: "Employer Name",
                Value:
                  res.data[0].coapplicant_primary_business_details?.EmployerName,
                section: "Primary Business Details",
              },
              {
                label: "Industry",
                Value:
                  res.data[0].coapplicant_primary_business_details?.Industry,
                section: "Primary Business Details",
              },
              {
                label: "Employment Vintage",
                Value:
                  res.data[0].coapplicant_primary_business_details?.DurationWithCurrentEmployer,
                section: "Primary Business Details",
              },
              {
                label: "Date of Joining",
                Value:
                  res.data[0].coapplicant_primary_business_details?.DateOfJoining,
                section: "Primary Business Details",
              },
              {
                label: "Gross Monthly Salary",
                Value:
                  res.data[0].coapplicant_primary_business_details?.Gross_Monthly_Salary,
                section: "Primary Business Details",
              },
               {
                label: "Fixed Salary",
                Value:
                  res.data[0].coapplicant_primary_business_details?.Gross_Monthly_Salary,
                section: "Primary Business Details",
              },
               {
                label: "Gross Monthly Salary",
                Value:
                  res.data[0].coapplicant_primary_business_details?.Gross_Monthly_Salary,
                section: "Primary Business Details",
              },
               {
                label: "Fixed Salary",
                Value:
                  res.data[0].coapplicant_primary_business_details?.Fixed_Salary,
                section: "Primary Business Details",
              },
              {
                label: "Variable / Incentive",
                Value:
                  res.data[0].coapplicant_primary_business_details?.Variable_Incentive,
                section: "Primary Business Details",
              },
              {
                label: "Other Allowances",
                Value:
                  res.data[0].coapplicant_primary_business_details?.Allowances,
                section: "Primary Business Details",
              },
              {
                label: "Work Location",
                Value:
                  res.data[0].coapplicant_primary_business_details?.Work_Location,
                section: "Primary Business Details",
              },
              {
                label: "Pan of Employer",
                Value:
                  res.data[0].coapplicant_primary_business_details?.Pan_of_Employer,
                section: "Primary Business Details",
              },
               {
                label: "PF Salary",
                Value:
                  res.data[0].coapplicant_primary_business_details?.PF_Salary,
                section: "Primary Business Details",
              },
               {
                label: "ESIC Salary",
                Value:
                  res.data[0].coapplicant_primary_business_details?.ESIC_Salary,
                section: "Primary Business Details",
              },
               {
                label: "Other Dedutions Salary",
                Value:
                  res.data[0].coapplicant_primary_business_details?.Other_Dedutions_Salary,
                section: "Primary Business Details",
              },
              {
                label: "Basic Salary",
                Value:
                  res.data[0].coapplicant_primary_business_details?.Basic_Salary,
                section: "Primary Business Details",
              },
              {
                label: "H R A Salary",
                Value:
                  res.data[0].coapplicant_primary_business_details?.HRA_Salary,
                section: "Primary Business Details",
              }

            );
          } else {
            arrayofCoapplicant.push(
              {
                label: "Business Type",
                Value: res.data[0].coapplicant_primary_business_details?.BusinessType,
                section: "Primary Business Details",
              },
              {
                label: "Business Name",
                Value:
                  res.data[0].coapplicant_primary_business_details?.BusinessName,
                section: "Primary Business Details",
              },
              {
                label: "Mantri Name",
                Value:
                  res.data[0].coapplicant_primary_business_details?.MantriName,
                section: "Primary Business Details",
              },
              {
                label: "Mantri Number",
                Value:
                  res.data[0].coapplicant_primary_business_details?.MantriNumber,
                section: "Primary Business Details",
              },
              {
                label: "Business Income(Monthly)",
                Value:
                  res.data[0].coapplicant_primary_business_details?.BusinessIncome,
                section: "Primary Business Details",
              },
              {
                label: "Business Vintage (Months)",
                Value:
                  res.data[0].coapplicant_primary_business_details?.BusinessVintage,
              },
              {
                label: "If Professional",
                Value:
                  res.data[0].coapplicant_primary_business_details?.IfProfessional,
                section: "Primary Business Details",
              },
              {
                label: "If Business",
                Value:
                  res.data[0].coapplicant_primary_business_details?.IfBusiness,
                section: "Primary Business Details",
              },
              {
                label: "Legal Status",
                Value:
                  res.data[0].coapplicant_primary_business_details?.LegalStatus,
                section: "Primary Business Details",
              },
              {
                label: "Workplace",
                Value: res.data[0].coapplicant_primary_business_details?.Workplace,
                section: "Primary Business Details",
              },
              {
                label: "Workplace Size",
                Value:
                  res.data[0].coapplicant_primary_business_details?.WorkplaceSize,
                section: "Primary Business Details",
              },
              {
                label: "Current Workplace Stability",
                Value:
                  res.data[0].coapplicant_primary_business_details?.WorkplaceStability,
                section: "Primary Business Details",
              },
              {
                label: "Number of Employees",
                Value:
                  res.data[0].coapplicant_primary_business_details?.NumberOfEmployees,
                section: "Primary Business Details",
              },
              {
                label: "Business IDs",
                Value:
                  res.data[0].coapplicant_primary_business_details?.BusinessID,
                section: "Primary Business Details",
              },
              {
                label: "Address",
                Value:
                  res.data[0].coapplicant_primary_business_details?.BusinessAddress,
                section: "Primary Business Details",
              },
              {
                label: "PIN Code",
                Value:
                  res.data[0].coapplicant_primary_business_details?.BusinessPincode,
                section: "Primary Business Details",
              },
              {
                label: "State",
                Value:
                  res.data[0].coapplicant_primary_business_details?.BusinessState,
                section: "Primary Business Details",
              },
              {
                label: "City",
                Value:
                  res.data[0].coapplicant_primary_business_details?.BusinessCity,
                section: "Primary Business Details",
              },
              {
                label: "Sub District",
                Value:
                  res.data[0].coapplicant_primary_business_details?.BusinessSubDist,
                section: "Primary Business Details",
              },
              {
                label: "Locality/Village",
                Value:
                  res.data[0].coapplicant_primary_business_details?.BusinessLocality,
                section: "Primary Business Details",
              },
              {
                label: "Landmark",
                Value:
                  res.data[0].coapplicant_primary_business_details?.BusinessLandmark,
                section: "Primary Business Details",
              }
            );
          }
        }

        setcoapplicantData(arrayofCoapplicant);
      })
      .catch((err) => {
        console.log(err);
      });

    setOpen(true);
    axios
      .post(url + "/coapplicant/viewdoc", {
        token: token,
        email: email,
        coapplicant_id: state.coapplicant_id,
        doc_name: finalDocName,
        doc_type: finalDocType,
        coapplicant_borrower_uniqueno: state.coapplicant_borrower_uniqueno,
      })

      .then((res) => {
        // console.log(res)
        setOpen(false);
        setBorrowerSelfie((prevState) => ({
          ...prevState,
          doc: res.data.doc_base64,
          type: finalDocType,
        }));
      })
      .catch((err) => {
        setOpen(false);
        console.log(err);
      });

  }, [token, email, state, finalDocName, finalDocType]);

  const requiredAddressFields = [
    "Residence Type",
    "Address",
    "PIN Code",
    "State",
    "City",
    "Sub District",
    "Locality/Village"
  ];

  const requiredPrimarySalariedFields = [
    "Nature of Business",
    "Company Type",
    "Designation Name",
    "Duration with Current Employer (In Months)",
    "Salary Mode",
    "Current Salary Income(Monthly)",
    "Previous Salary",
    "Job Vintage (Months)",
    "Office Number",
    "Office HR Number",
    "Department",
    "Employee Code",
    "Date of Joining",
    "Company Address",
    "Company PIN Code",
    "Company State",
    "Company City",
    "Company Sub District",
    "Company Locality/Village",
    "Company Landmark",
  ];


  const requiredPrimarySelfEmployeedFields = [
    "Business Type",
    "Business Name",
    // "Mantri Name",
    // "Mantri Number",
    "Business Income(Monthly)",
    "Business Vintage (Months)",
    "If Professional",
    "If Business",
    "Legal Status",
    "Workplace",
    "Workplace Size",
    "Current Workplace Stability",
    "Number of Employees",
    "Business IDs",
    "Address",
    "PIN Code",
    "State",
    "City",
    "Sub District",
    "Locality/Village",
    "Landmark"
  ];

  const surrogateSalariedFields = [
    "Nature of Business",
    "Designation Name",
    "Duration with Current Employer (In Months)",
    "Salary Mode",
    "Current Salary Income(Monthly)",
    "Previous Salary",
    "Job Vintage (Months)",
    "Office Number",
    "Office HR Number",
    "Company Address",
    "Pin Code",
    "State Name",
    "City Name",
    "Sub District",
    "Locality/Village",
    "Landmark"
  ];
  
  const surrogateSelfEmployeedFields = [
    "Business Type",
    "Business Name",
    // "Mantri Name",
    // "Mantri Number",
    "Business Income(Monthly)",
    "Business Vintage (Months)",
    "Income Mode",
    "Address",
    "Pin Code",
    "State Name",
    "City Name",
    "Sub District",
    "Locality/Village",
    "Landmark"
  ];

  const requiredObligationFields = [
    "Number of Active Loans",
    "Total Monthly Active EMI Amount",
  ];

  const checkAddressDetails = () => {
    return requiredAddressFields.every((key) => {
      const field = coapplicantData.find((item) => item.label === key);
      return field && field.Value !== undefined && field.Value !== null && field.Value !== '';
    });
  };

  const checkPrimaryDetails = (coapplicantData, professionType) => {
    const requiredFields = professionType === "SALARIED" ? requiredPrimarySalariedFields : requiredPrimarySelfEmployeedFields;
  
    if (!Array.isArray(coapplicantData) || coapplicantData.length === 0) {
      console.log('coapplicantData is either not an array or is empty');
      return false;
    }
  
    const missingFields = requiredFields.filter((key) => {
      const field = coapplicantData.find((item) => item.label === key);
      return !field || field.Value === undefined || field.Value === null || field.Value === '';
    });
  
    if (missingFields.length > 0) {
      console.log('Missing fields:', missingFields);
      return false;
    }
  
    return true;
  };

  const checkSurrogateDetails = (coapplicantData, professionTypes) => {
    const requiredFields = professionTypes === "SALARIED" ? surrogateSalariedFields : surrogateSelfEmployeedFields;
  
    if (!Array.isArray(coapplicantData) || coapplicantData.length === 0) {
      console.log('coapplicantData is either not an array or is empty');
      return false;
    }
  
    const missingFields = requiredFields.filter((key) => {
      const field = coapplicantData.find((item) => item.label === key);
      return !field || field.Value === undefined || field.Value === null || field.Value === '';
    });
  
    if (missingFields.length > 0) {
      console.log('Missing fields:', missingFields);
      return false;
    }
  
    return true;
  };

 
  const checkObligationDetails = () => {
    return requiredObligationFields.every((key) => {
      const field = coapplicantData.find((item) => item.label === key);
      return field && field.Value !== undefined && field.Value !== null && field.Value !== '';
    });
  };

  const toggleFieldsetMobile = () => {
    setShowFieldset((prevShowFieldset) => !prevShowFieldset);
  };

  const handleMobileChange = (event) => {
    setEditedMobile(event.target.value);
  };

  const handleEmailChange = (event) => {
    setEditedEmail(event.target.value);
    if (event) {
      setSaveBtnDisabled2(false);
    }
  };

  const handleSubmitMobile = async () => {
    try {
      const submitReq = await axios.patch(url + "/coapplicant/edit/email/mobile", {
        token: TOKEN,
        email: EMAIL,
        coapplicantId: state.coapplicant_id,
        updatedMobile: editedMobile,
        toChange: 'Mobile'
      });
      console.log(submitReq.data);
      if (submitReq.data.auth === true) {
        toast.success(submitReq.data.message);
        setEditBtnDisabled(true);
        setShowFieldset(false);
        setIsEditableMobile(false);
        setSaveBtnDisabled(true);
      } else {
        toast.error(submitReq.data.message);
        setSaveBtnDisabled(true);
      }
    } catch (error) {
      console.log(error);
    }
  }

  async function handleUploadConsent(event) {
    console.log(file);
    try {
      const selectedFile = event.target.files[0];
      setFile(selectedFile);
      if (selectedFile) {
        if (selectedFile.type === "application/pdf") {
          setFile(selectedFile);
        } else {
          toast.error("Invalid File Format. Choose PDF only");
          event.target.value = null;
          return;
        }
        const reader = new FileReader();
        reader.onloadend = async () => {
          const base64Data = reader.result.split(",")[1];

          const sendDoc = await axios.post(url + "/coapplicant/adddocument", {
            token: TOKEN,
            email: EMAIL,
            coapplicant_id: state.coapplicant_id,
            coapplicant_borrower_uniqueno: coapplicantBorrowerUniqueNo,
            fileName: base64Data,
            doc_name: "coapplicant_misc_doc",
            doc_type: "pdf",
          });

          console.log(sendDoc.data);
          if (sendDoc.data.auth === true) {
            toast.success(sendDoc.data.message);
            setEditBtnDisabled(false)
          } else {
            toast.error(sendDoc.data.message);
          }
        }
        reader.readAsDataURL(selectedFile);
      }
    } catch (error) {
      console.log(error);
    }
  }

  const handleFile = () => {
    document.getElementById('fileInput').click();
  };

  async function handleEditMobile() {
    setIsEditableMobile(true);
  }

  const handleVerifyNumber = async () => {
    const sendOtp = await axios.post(url + "/user/lms/otp/send", {
      templateId: "66629e65d6fc051d3e128092",
      email: EMAIL,
      token: TOKEN,
      borrowerMobile: editedMobile,
      VAR1: coapplicantName,
      VAR2: 'Mobile Number'
    })

    if (sendOtp.data.type === "success") {
      toast.success("OTP Sent to " + editedMobile);
      setTimeout(() => {
        const otp = prompt("Please Enter OTP received at " + editedMobile);
        handleVerify(otp, editedMobile);
        setBorrowerOtp(otp);
        console.log(borrowerOtp);
      }, 4000);
    } else {
      toast.error(sendOtp.data.type);
      return;
    }
  }

  const handleVerify = async (otp, phone) => {
    const verify = await axios.post(url + "/user/lms/otp/verify", {
      borrowerOtp: otp,
      borrowerMobile: phone,
      email: EMAIL,
      token: TOKEN,
    })

    if (verify.data.type === "success") {
      toast.success("OTP Verification Successful");
      setEditedMobile(phone);
      setIsEditableMobile(false);
      setEditBtnDisabled(true);
      setSaveBtnDisabled(false);
    } else {
      toast.error("Invalid OTP Please Try Again");
      return;
    }
  }

  const handleOtp = async () => {
    const sendOtp = await axios.post(url + "/user/lms/otp/send", {
      templateId: "66629e65d6fc051d3e128092",
      email: EMAIL,
      token: TOKEN,
      borrowerMobile: editedMobile,
      VAR1: coapplicantName,
      VAR2: 'Email Id'
    })

    if (sendOtp.data.type === "success") {
      toast.success("OTP Sent to " + editedMobile);
      setTimeout(() => {
        const otp = prompt("Please Enter OTP received at " + editedMobile);
        handleVerify2(otp, editedMobile);
        setBorrowerOtp(otp)
      }, 4000);
    } else {
      toast.error(sendOtp.data.type);
      return;
    }
  }

  const handleVerify2 = async (otp, phone) => {
    const verify = await axios.post(url + "/user/lms/otp/verify", {
      borrowerOtp: otp,
      borrowerMobile: phone,
      email: EMAIL,
      token: TOKEN,
    })

    if (verify.data.type === "success") {
      toast.success("OTP Verification Successful");
      setEditBtnDisabled2(false);
    } else {
      toast.error("Invalid OTP Please Try Again");
      return;
    }
  }

  const toggleFieldsetEmail = () => {
    setShowFieldset2((prevShowFieldset2) => !prevShowFieldset2);
  };

  const handleEditEmail = async () => {
    setIsEditableEmail(true);
  }

  const handleSubmitEmail = async () => {
    try {
      const submitReq = await axios.patch(url + "/coapplicant/edit/email/mobile", {
        token: TOKEN,
        email: EMAIL,
        coapplicantId: state.coapplicant_id,
        updatedEmail: editedEmail,
        toChange: 'Email'
      });
      if (submitReq.data.auth === true) {
        toast.success(submitReq.data.message);
        setEditBtnDisabled2(true);
        setShowFieldset2(false);
        setIsEditableEmail(false);
        setSaveBtnDisabled2(true);
      } else {
        toast.error(submitReq.data.message)
      }
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    setAddressPresent(checkAddressDetails());
    setPrimaryPresent(checkPrimaryDetails(coapplicantData, coapplicantProfession));
    setSurrogatePresent(checkSurrogateDetails(coapplicantData, surrogateType));
    setObligationPresent(checkObligationDetails());
    //eslint-disable-next-line
  }, [coapplicantData]);

  // console.log(coapplicantData)

  // console.log(addressPresent)
  // console.log(primaryPresent)
  // console.log(surrogatePresent)
  // console.log(obligationPresent)

  const formatDate = async (dateString) => {
    console.log(dateString);
    if (dateString && typeof dateString === 'string') {
      
      const dateOnly = dateString.includes('T') ? dateString.split('T')[0] : dateString;
      
      const dateParts = dateOnly.split('-');
      if (dateParts.length === 3 && dateParts[0].length === 4) {
        return `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`;
      }
    }
    return 'N/A';
  
  }

  useEffect(() => {
    
      if (coapplicantDob) {
        formatDate(coapplicantDob).then((formattedDate) => {
          setFormattedDob(formattedDate);
        });
      }

      if (coapplicant_dateofmarriage) {
        formatDate(coapplicant_dateofmarriage).then((formattedDate) => {
          setFormattedDom(formattedDate);
        });
      }
    
  }, [coapplicantDob, coapplicant_dateofmarriage]);

  return (
    <>
      <div style={{ height: "20px" }} />
      <Sidebar click={openView} />
      <div style={{ marginLeft: isOpen ? "15%" : "0", transition: "all 0.2s" }}>
        <div className="main-container">
          <div className="content-container">
            <h3 className="main-heading">
              <GroupAddIcon />
              View Co-applicant Details
            </h3>
            {openModal && (
              <CoapplicantModal
                coapplicantData={coapplicantData}
                closeModalDetails={closeModalDetails}
                modalData={modalData}
              />
            )}
            <div className="div-first">
              <div>
                <p style={{ fontSize: "1.2rem", fontWeight: "bold" }}>
                  Borrower ID:&nbsp;&nbsp;
                  {coapplicantBorrowerUniqueNo}
                </p>
              </div>
              <div>
                <p style={{ fontSize: "1.2rem", fontWeight: "bold" }}>
                  Loan ID:&nbsp;&nbsp;{coapplicantLoanId}
                </p>
              </div>
              <div>
                <p style={{ fontSize: "1.2rem", fontWeight: "bold" }}>
                  Name:&nbsp;&nbsp;{coapplicantName}
                </p>
              </div>
              <div>
                <p>
                  <strong>Pan Number:</strong>&nbsp;&nbsp;{coapplicant_panno}
                </p>
              </div>
              <div>
                <p>
                  <strong>Voter Number:</strong>&nbsp;&nbsp;
                  {coapplicant_voterno}
                </p>
              </div>
              <div>
                <p>
                  <strong>Aadhar Number:</strong> &nbsp;&nbsp;
                  {coapplicant_aadharno}
                </p>
              </div>
            </div>

            <div className="div-second">
              {photoUrl && (
                <div>
                  <div>
                    <img
                      src={`data:image/${borrowerSelfie.type};base64,${borrowerSelfie.doc}`}
                      alt="Not found"
                      style={{
                        borderRadius: "20px",
                        width: "350px",
                        height: "250px",
                      }}
                    />
                  </div>
                </div>
              )}

              <div style={{ lineHeight: "3rem" }}>
                <div>
                  <p>
                    {/* <strong>Date of Birth:</strong>&nbsp;&nbsp;{coapplicantDob} */}
                    <strong>Date of Birth:</strong>&nbsp;&nbsp;{formattedDob}
                  </p>
                </div>
                <div>
                  <p>
                    <strong>Gender:</strong>&nbsp;&nbsp;{coapplicantGender}
                  </p>
                </div>
                <div>
                  <p>
                    <strong>Mobile number:</strong>&nbsp;&nbsp;
                    {/* {coapplicantPhoneNumber} */}
                    {isEditableMobile ? (
                      <>
                        <input type="text" name="mobile" style={{ width: '100px', borderRadius: "5px" }} value={editedMobile} onChange={handleMobileChange} />
                        <button className="verifyButton" onClick={handleVerifyNumber}>verify</button>
                      </>
                    ) : (
                      <>{editedMobile} {editPermission && (<button onClick={toggleFieldsetMobile} style={{ marginLeft: "15px", background: 'none', border: 'none', color: 'blue', cursor: 'pointer', padding: 0 }}>(Update)</button>)}</>
                    )}
                    {showFieldset && (
                      <div>
                        <fieldset className="box">
                          <legend>Edit Mobile Number</legend>
                          <div className="main">
                            <input id="fileInput" type="file" style={{ display: 'none' }} onChange={handleUploadConsent} />
                            <button className="uploadBtn" onClick={handleFile}>
                              Upload Consent
                            </button>
                            <button className="editBtn" disabled={editBtnDisabled} onClick={handleEditMobile} >
                              Edit
                            </button>
                            <button className="saveBtn" disabled={saveBtnDisabled} onClick={handleSubmitMobile}>
                              Save
                            </button>
                          </div>
                        </fieldset>
                      </div>
                    )}
                  </p>
                </div>
                <div>
                  <p>
                    <strong>E-mail:</strong>&nbsp;&nbsp;
                    {/* {coapplicantEmail} */}
                    {isEditableEmail ? (
                      <>
                        <input type="text" name="email" style={{ width: '200px' }} value={editedEmail} onChange={handleEmailChange} />
                      </>
                    ) : (
                      <>{editedEmail} {editPermission && (<button onClick={toggleFieldsetEmail} style={{ marginLeft: "15px", background: 'none', border: 'none', color: 'blue', cursor: 'pointer', padding: 0 }}>(Update)</button>)}</>
                    )}
                
                    {showFieldset2 && (
                      <div>
                        <fieldset className="box">
                          <legend>Edit Email ID</legend>
                          <div className="main">
                            <button className="uploadBtn" onClick={handleOtp}>
                              Send OTP
                            </button>
                            <button className="editBtn" disabled={editBtnDisabled2} onClick={handleEditEmail}>
                              Edit
                            </button>
                            <button className="saveBtn" disabled={saveBtnDisabled2} onClick={handleSubmitEmail}>
                              Save
                            </button>
                          </div>
                        </fieldset>
                      </div>
                    )}
                  </p>
                </div>
                <div>
                  <p>
                    <strong>Maritial Status:</strong>&nbsp;&nbsp;
                    {coapplicantMaritalStatus}
                  </p>
                </div>
                <div>
                  <p>
                    <strong>Education Qualification:</strong>&nbsp;&nbsp;
                    {coapplicantEducationalQualification}
                  </p>
                </div>
              </div>
            </div>

            <div className="coapplicant-details">
              <div>
                <p>
                  <strong>Relationship with Applicant:</strong>&nbsp;&nbsp;
                  {coapplicantRelationship}
                </p>
              </div>
              <div>
                <p>
                  <strong>Father Name:</strong>&nbsp;&nbsp;
                  {coapplicantFatherName}
                </p>
              </div>
              <div>
                <p>
                  <strong>Type Of Profession:</strong>&nbsp;&nbsp;
                  {coapplicantProfession}{" "}
                </p>
              </div>
              <div>
                <p>
                  <strong>Is Co-applicant income is computed:</strong>
                  &nbsp;&nbsp;{coapplicant_compute_income}
                </p>
              </div>
              <div>
                <p>
                  <strong>Category:</strong>&nbsp;&nbsp;{coapplicant_category}
                </p>
              </div>
              <div>
                <p>
                  <strong>Mother Tongue:</strong>&nbsp;&nbsp;
                  {coapplicant_mothertongue}
                </p>
              </div>

              <div>
                <p>
                  <strong>Religion:</strong>&nbsp;&nbsp;{coapplicant_religion}
                </p>
              </div>

              {coapplicant_dateofmarriage && (
                <div>
                  <p>
                    <strong>Date of Marriage:</strong>&nbsp;&nbsp;
                    {/* {coapplicant_dateofmarriage ? coapplicant_dateofmarriage.slice(0,10):""} */}
                    {formattedDom}
                  </p>
                </div>
              )}
              <div>
                <p>
                  <strong>Family Structure:</strong>&nbsp;&nbsp;
                  {coapplicant_familystructure}
                </p>
              </div>
            </div>

            <div className="modal-div">
              <div className="address-details">
                <h3 style={{ color: addressPresent ? 'green' : 'red' }}>Address Details</h3>
                <span>
                  <AiOutlineEye
                    cursor="pointer"
                    size={17}
                    onClick={() => openModalDetails("Co-applicant Details")}
                  />
                </span>
              </div>

              <div className="primary-details">
                <h3 style={{ color: primaryPresent ? 'green' : 'red' }}>Primary Business Details</h3>
                <span>
                  <AiOutlineEye
                    cursor="pointer"
                    size={17}
                    onClick={() => openModalDetails("Primary Business Details")}
                  />{" "}
                </span>
              </div>

              <div className="surrogate-details">
                <h3 style={{ color: surrogatePresent ? 'green' : 'red' }}>Surrogate Business Details</h3>
                <span>
                  <AiOutlineEye
                    cursor="pointer"
                    size={17}
                    onClick={() => openModalDetails("Surrogate")}
                  />{" "}
                </span>
              </div>

              <div className="obligation-details">
                <h3 style={{ color: obligationPresent ? 'green' : 'red' }}>Obligations</h3>
                <span>
                  <AiOutlineEye
                    cursor="pointer"
                    size={17}
                    onClick={() => openModalDetails("Obligations")}
                  />{" "}
                </span>
              </div>
            </div>

          </div>
        </div>
        <ToastContainer />
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={open}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      </div>
    </>
  );
};

export default ViewCoApplicantDetails;
